export const en = {
  //languages
  "languages.english": "English (US)",
  "languages.portuguese": "Portuguese (BR)",

  //toggle
  "toggle.theme": "Toggle theme",
  "toggle.language": "Toggle language",
  "toggle.menu": "Menu",

  //generic
  "generic.success": "Success",
  "generic.error": "An error occurred",
  "generic.redirecting": "Redirecting...",
  "generic.loading": "Loading...",
  "generic.search": "Search...",
  "generic.selectAnOption": "Select an option...",
  "generic.next": "Next",
  "generic.noResultsFound": "No results found.",
  "generic.yourEmail": "your-email@email.com",
  "generic.cancel": "Cancel",
  "generic.confirm": "Confirm",
  "generic.save": "Save",
  "generic.copy": "Copy",
  "generic.or": "Or",
  "generic.edit": "Edit",
  "generic.delete": "Delete",
  "generic.import": "Import",
  "generic.new": "New",
  "generic.reset": "Reset",
  "generic.create": "Create",
  "generic.close": "Close",
  "generic.update": "Update",
  "generic.upload": "Upload",
  "generic.download": "Download",
  "generic.confirmDelete": "Are you sure you want to delete this item?",
  "generic.confirmDeleteDescription":
    "This action cannot be undone. This will permanently delete: ",
  "generic.manage": "Manage",
  "generic.logout": "Logout",
  "generic.settings": "Settings",
  "generic.previous": "Previous",
  "generic.actions": "Actions",
  "generic.goBack": "Go Back",
  "generic.register": "Register",
  "generic.add": "Add",
  "generic.removeLast": "Remove Last",
  "generic.deleting": "Deleting...",
  //components redirect-message
  "components.redirectMessage.redirectIn": "Redirecting in",
  "components.redirectMessage.seconds": "seconds",

  //components loading
  "components.loading.loading": "Loading",

  //components date-picker
  "components.date-picker.months.january": "January",
  "components.date-picker.months.february": "February",
  "components.date-picker.months.march": "March",
  "components.date-picker.months.april": "April",
  "components.date-picker.months.may": "May",
  "components.date-picker.months.june": "June",
  "components.date-picker.months.july": "July",
  "components.date-picker.months.august": "August",
  "components.date-picker.months.september": "September",
  "components.date-picker.months.october": "October",
  "components.date-picker.months.november": "November",
  "components.date-picker.months.december": "December",

  // Auth
  "auth.login": "Login",
  "auth.register": "Sign up",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.confirmPassword": "Confirm password",
  "auth.fullName": "Full name",
  "auth.terms": "I accept the terms of use",
  "auth.googleLogin": "Login with Google",
  "auth.facebookLogin": "Login with Facebook",
  "auth.emailLogin": "Login with email",
  "auth.enterAccount": "Enter your account to access the dashboard",
  "auth.forgotPassword": "Forgot your password?",
  "auth.doNotHaveAccount": "Don't have an account?",
  "auth.alreadyHaveAccount": "Already have an account?",
  "auth.registerWithEmail": "Or sign up with email",
  "auth.createYourAccount": "Create your account to start using",
  "auth.failedToLoginWithFacebook": "Failed to login with Facebook",
  "auth.failedToLoginWithGoogle": "Failed to login with Google",
  "auth.verifyEmailToConfirmAccount":
    "Verify your email to confirm your account",
  "auth.registerSuccess": "Registration successful",
  "auth.registerFailed": "Registration failed, please try again",
  "auth.loginSuccess": "Login successful",
  "auth.loginFailed": "Login failed, please try again",
  "auth.confirmAccountSuccess": "Account confirmed successfully",
  "auth.confirmAccountFailed": "Error confirming account, please try again",
  "auth.emailSent": "Email sent",
  "auth.checkEmailToResetPassword": "Check your email to reset your password",
  "auth.emailSentFailed": "Failed to send email",
  "auth.emailSentFailedMessage":
    "Unable to send the password reset email. Please try again later.",
  "auth.reCaptchaFailed": "Failed to verify reCAPTCHA",
  "auth.forgotPasswordDescription": "Enter your email to reset your password",
  "auth.forgotPasswordSuccess": "Password reset email sent successfully",
  "auth.forgotPasswordFailed": "Failed to send password reset email",
  "auth.forgotPasswordFailedMessage":
    "Unable to send the password reset email. Please try again later.",
  "auth.resetPasswordSuccess": "Your password has been reset successfully.",
  "auth.resetPasswordError":
    "Failed to reset password, token expired, try to user forgot password again.",
  "auth.resetPassword": "Reset password",
  "auth.resetPasswordDescription":
    "Create a new password to access the dashboard",
  "auth.twoFactor": "Two-Factor Authentication",
  "auth.twoFactorDescriptionEmail": "We sent a verification code to your email",
  "auth.twoFactorDescriptionApp":
    "Enter the verification code from your authenticator app",

  // Dashboard
  "dashboard.home": "Home",
  "dashboard.title": "Dashboard",
  "dashboard.platform": "Platforms",
  "dashboard.insuranceCompanies": "Insurance Companies",
  "dashboard.users": "Users",
  "dashboard.products": "Products",
  "dashboard.advertisers": "Advertisers",
  "dashboard.invoices": "Invoices",
  "dashboard.clients": "Partners",
  "dashboard.clients.sub.list": "Partner list",
  "dashboard.clients.sub.linkUsers": "Link users",
  "dashboard.clients.sub.projects": "Projects",
  "dashboard.clients.sub.campaigns": "Campaigns",
  "dashboard.clients.myPartner": "My partner",

  "partnerSelect.title": "Select partner",
  "partnerSelect.description":
    "Choose a partner to continue. You will be redirected to the selected area.",
  "partnerSelect.loading": "Loading partners…",
  "partnerSelect.error": "Could not load partners.",
  "partnerSelect.empty": "No partners found.",
  "partnerSelect.choose": "Continue",
  "dashboard.campaigns": "Campaigns",
  "dashboard.whatsappMeta": "WhatsApp (Meta)",
  "dashboard.settings": "Settings",

  //dashboard advertisers
  "dashboard.advertisers.activeCampaign": "Active Campaign",
  "dashboard.advertisers.pendingCampaign": "Under Review Campaign",
  "dashboard.advertisers.finishedCampaign": "Finished Campaign",
  "dashboard.advertisers.rejectedCampaign": "Rejected Campaign",
  "dashboard.advertisers.fullImpact": "Full Impact",

  //validation messages
  "validationMessages.invalidId": "Invalid Id",
  "validationMessages.invalidEmail": "Invalid email",
  "validationMessages.numericMessage": "Value must be a number",
  "validationMessages.minLengthMessage": "The minimum length must be ",
  "validationMessages.maxLengthMessage": "The maximum length must be ",
  "validationMessages.minValueMessage": "The minimum value must be ",
  "validationMessages.positiveValueMessage": "The value must be positive",
  "validationMessages.invalidDateMessage": "Invalid date",
  "validationMessages.enumMessage": "Select an option",
  "validationMessages.requiredMessage": "Required",
  "validationMessages.passwordRuleMessage":
    "The password must contain at least one letter, one number and one special character",
  "validationMessages.equalPasswordMessage": "The passwords must be the same",
  "validationMessages.acceptTermsMessage": "You must accept the terms of use",
  "validationMessages.invalidOptionMessage": "Select an option",
  "validationMessages.invalidCPF": "Invalid CPF",
  "validationMessages.invalidCNPJ": "Invalid CNPJ",
  "validationMessages.selectPartnerType": "You must select a partner type",
  "validationMessages.selectBusinessClassification": "You must select a business classification",
  "validationMessages.selectCompanyLogo": "You must select a company logo",
  "validationMessages.selectCnpjCard": "You must select a CNPJ document",
  "validationMessages.selectContractDocument": "You must select a contract document",
  "validationMessages.selectAtLeastOneContract": "You must select at least one signed contract",

  //settings
  "settings.title": "Settings",
  "settings.description": "Manage your account settings and preferences",
  "settings.menu.profile": "Profile and Security",
  "settings.menu.billing": "Billing",
  "settings.profile.title": "Personal information",
  "settings.profileUpdated": "Profile updated successfully",
  "settings.profile.fullName": "Full Name",
  "settings.profile.securityTitle": "Account security",
  "settings.profile.mfaTitle": "Two-Factor Authentication",
  "settings.profile.mfaDescription":
    "Add an extra layer of security to your account",
  "settings.profile.mfaMethod": "Authentication method",
  "settings.profile.mfaMethodDescription":
    "Choose how you want to receive the verification codes",
  "settings.profile.mfaMethodApp": "Authenticator app",
  "settings.profile.mfaSecretCopied": "Secret copied successfully",
  "settings.profile.enableMfa": "Enable two-factor authentication",
  "settings.profile.scanQrCodeOrCopySecret":
    "Scan the QR code with the authenticator app or copy the secret code",
  "settings.profile.mfaKeyReminder":
    "Make sure you validated your OTP using the keys above",
  "settings.profile.personType": "Person type",
  "settings.profile.personTypeCompany": "Company",
  "settings.profile.personTypePerson": "Person",
  "settings.security.passwordManagement": "Password management",
  "settings.security.title": "Account security",
  "settings.security.changePassword": "Change password",
  "settings.security.currentPassword": "Current password",
  "settings.security.newPassword": "New password",
  "settings.security.confirmNewPassword": "Confirm new password",
  "settings.security.passwordUpdated": "Password updated successfully",

  //clients
  "clients.title": "Partners",
  "clients.subtitle.partnerPlans": "Partner Plans",
  "clients.description": "Manage your partners",
  "clients.form.create.title": "Create Partner",
  "clients.form.create.description": "Create a new Partner to start using",
  "clients.form.edit.title": "Edit Partner",
  "clients.form.edit.description": "Edit the Partner information",
  "clients.form.fields.name": "Name",
  "clients.form.fields.cnpj": "CNPJ",
  "clients.form.fields.corporate_name": "Corporate Name",
  "clients.form.fields.type.partner": "Partner Type",
  "clients.form.fields.type.partner.client": "Client",
  "clients.form.fields.type.partner.businessIndicator":
    "Business Indicator - Hunter",
  "clients.form.fields.provider": "AI provider",
  "clients.form.fields.aiModel": "AI model",
  "clients.form.fields.hasTokenLimit": "Has token limit",
  "clients.form.fields.tokenLimit": "Token limit",
  "clients.form.descriptions.hasTokenLimit":
    "When the token limit is reached, the Partner will stop working until the limit is reset",
  "clients.plan-form.soulhubSingleProduct": "Single SoulHub product",
  "clients.plan-form.soulhubSingleProductHint":
    "Sync this bundle as one SoulHub product: plan name, merged descriptions, and plan price.",
  "clients.plan-form.soulhubAnchorProduct":
    "Anchor product for type and codes",
  "clients.plan-form.soulhubAnchorProductHint":
    "Optional. If set, this product will be used as the anchor for type and codes in plan→product sync.",
  "clients.noPartners": "No partners found",
  "clients.knowledgeImport": "Knowledge Import",
  "clients.knowledgeBase": "Knowledge Base",
  "clients.actions.copyApiKey": "Copy API key",
  "clients.success.apiKeyCopied": "API key copied successfully",
  "clients.success.partnerDeleted": "Partner deleted successfully",
  "clients.success.partnerUpdated": "Partner updated successfully",
  "clients.success.partnerCreated": "Partner created successfully",
  "clients.success.partnerApproved": "Partner approved successfully",
  "clients.success.partnerRejected": "Partner rejected successfully",
  "clients.success.clientCreated": "Registration completed successfully!",
  "clients.success.clientUpdated": "Data updated successfully!",
  "clients.success.modalTitle": "Registration Complete!",
  "clients.success.modalDescription":
    "Your registration has been submitted successfully. Our team will contact you soon to finalize the process.",
  "clients.success.goToLogin": "Go to Login",
  "clients.errors.approveFailed": "Error approving Partner",
  "clients.errors.rejectFailed": "Error rejecting Partner",
  "clients.errors.createFailed": "Error creating registration",
  "clients.errors.updateFailed": "Error updating data",
  "clients.review.title": "Partner Data Review",
  "clients.review.description":
    "Review the company data before approving or rejecting",
  "clients.review.basicInfo": "Basic Information",
  "clients.review.address": "Address",
  "clients.review.representative": "Company Representative",
  "clients.form.sections.companyRepresentative": "Company Representative",
  "clients.form.sections.bankData": "Bank Account",
  "clients.form.fields.pix_key": "PIX key",
  "clients.form.placeholders.pix_key":
    "CPF, CNPJ, email, phone, or random key (optional)",
  "clients.review.bankAccount": "Bank Account",
  "clients.review.pixKey": "PIX key",
  "clients.review.documents": "Documents",
  "clients.review.terms": "Terms and Conditions",
  "clients.review.rejectionModal.title": "Rejection Reason",
  "clients.review.rejectionModal.reason": "Rejection reason",
  "clients.review.rejectionModal.placeholder":
    "Describe the reason why the company is being rejected...",
  "clients.review.rejectionModal.confirm": "Confirm Rejection",
  "clients.review.actions.approve": "Approve Company",
  "clients.review.actions.reject": "Reject Data",
  "clients.review.actions.cancel": "Cancel",
  "clients.review.view": "View Data",
  "clients.review.loading": "Loading Partner data...",
  "clients.review.notInformed": "Not informed",
  "clients.review.sent": "Sent",
  "clients.review.notSent": "Not sent",
  "clients.review.yes": "Yes",
  "clients.review.no": "No",
  "clients.partnerPortal.title": "Partner portal access",
  "clients.partnerPortal.description":
    "Create the master login for this partner organization (email and password).",
  "clients.partnerPortal.email": "Email",
  "clients.partnerPortal.password": "Password",
  "clients.partnerPortal.confirmPassword": "Confirm password",
  "clients.partnerPortal.useRepresentative": "Use company representative data",
  "clients.partnerPortal.manualSection": "User profile (manual)",
  "clients.partnerPortal.submit": "Create portal access",
  "clients.partnerPortal.masterExists":
    "A master user already exists for this partner.",
  "clients.partnerPortal.createSuccess": "Partner portal access created.",
  "clients.partnerPortal.createError": "Could not create portal access.",
  "clients.partnerPortal.manualRequired":
    "Fill in the manual profile or enable representative data.",
  "clients.success.planSaved": "Plan saved successfully",
  "clients.success.planDeleted": "Plan deleted successfully",
  "clients.partner": "Partner",
  "clients.form.fields.prompt": "Prompt",
  "clients.form.placeholders.name": "Enter partner name",
  "clients.form.placeholders.prompt": "Enter prompt",
  "clients.form.placeholders.provider": "Select provider",
  "clients.form.placeholders.tokenLimit": "Enter token limit",
  //users
  "users.title": "Users",
  "users.subtitle": "Users Registration",
  "users.description": "Manage your users",
  "users.form.create.title": "Create user",
  "users.form.create.description": "Create a new user to start using",
  "users.form.edit.title": "Edit user",
  "users.form.edit.description": "Edit the user information",

  //advertisers
  "advertisers.title": "Advertisers",
  "advertisers.description": "Manage your advertisers",

  //invoices
  "invoices.title": "Invoices",
  "invoices.description": "Manage your invoices",

  //platforms
  "platform.title": "My platforms",
  "platform.description": "Manage your platforms",
  "platform.form.fields.name": "Company name",
  "platform.form.fields.cnpj": "CNPJ",
  "platform.form.fields.namePlatform": "Platform name",
  "platforms.plataform.form.noProductsInCombo":
    "No products selected for this combo.",
  "platforms.plataform.form.comboName": "Combo name",
  "platforms.plataform.form.comboDescription": "Combo description",
  "platforms.plataform.form.comboPrice": "Combo price",
  "platforms.plataform.form.comboProducts": "Combo products",
  "platform.form.placeholders.name": "Enter the platform name",
  "platform.form.placeholders.cnpj": "Enter the CNPJ of the platform",
  "platform.form.placeholders.namePlatform": "Enter the platform name",

  //insurance companies
  "insuranceCompanies.title": "Insurance Companies",
  "insuranceCompanies.description": "Manage your insurance companies",
  "insuranceCompanies.form.fields.name": "Company name",
  "insuranceCompanies.form.fields.corporateName": "Corporate name",
  "insuranceCompanies.form.fields.cnpj": "CNPJ",
  "insuranceCompanies.no_insurance_companies": "No insurance companies found",
  "insuranceCompanies.name": "Name",
  "insuranceCompanies.cnpj": "CNPJ",
  "insuranceCompanies.corporate_name": "Corporate name",
  "insuranceCompanies.type": "Type",
  "insuranceCompanies.form.fields.type": "Company type",
  "insuranceCompanies.form.fields.type.insurance": "Insurance",
  "insuranceCompanies.form.fields.type.guarantor": "Guarantor",
  "insuranceCompanies.success.insuranceCompanyCreated":
    "Insurance company created successfully",

  //reports
  "reports.title": "Reports",
  "reports.description": "Manage your reports",

  //reports filters
  "reports.filters.title": "Filters",
  "reports.filters.saleId": "Sale ID",
  "reports.filters.saleIdPlaceholder":
    "Enter one or more IDs (comma separated)",
  "reports.filters.status": "Status",
  "reports.filters.statusPlaceholder": "Select status",
  "reports.filters.partnerName": "Partner",
  "reports.filters.partnerNamePlaceholder": "Select partner",
  "reports.filters.clientName": "Client Name",
  "reports.filters.clientNamePlaceholder": "Enter client name",
  "reports.filters.clientCpf": "Client CPF",
  "reports.filters.clientCpfPlaceholder": "Enter client CPF",
  "reports.filters.startDate": "Start Date",
  "reports.filters.endDate": "End Date",
  "reports.filters.minimumPrice": "Minimum Price ($)",
  "reports.filters.minimumPricePlaceholder": "Enter minimum price",
  "reports.filters.maximumPrice": "Maximum Price ($)",
  "reports.filters.maximumPricePlaceholder": "Enter maximum price",
  "reports.filters.apply": "Apply Filters",
  "reports.filters.clear": "Clear Filters",

  //reports pagination
  "reports.pagination.showing": "Showing",
  "reports.pagination.to": "to",
  "reports.pagination.of": "of",
  "reports.pagination.results": "results",
  "reports.pagination.previous": "Previous",
  "reports.pagination.next": "Next",

  //reports table
  "reports.table.saleId": "Sale ID",
  "reports.table.planName": "Plan",
  "reports.table.partnerName": "Partner",
  "reports.table.clientName": "Client",
  "reports.table.clientCpf": "CPF",
  "reports.table.salePrice": "Sale Price",
  "reports.table.status": "Status",
  "reports.table.saleDate": "Date",
  "reports.table.details": "Details",
  "reports.table.viewDetails": "View",

  //reports no sales
  "reports.noSales": "No sales found",

  //reports status
  "reports.status.pending": "Pending",
  "reports.status.approved": "Approved",
  "reports.status.failed": "Failed",
  "reports.status.refunded": "Refunded",
  "reports.status.rejected": "Rejected",
  "reports.status.cancelled": "Cancelled",

  //products
  "products.title": "Products",
  "products.description": "Manage your products",
  "products.button.new.combo": "New combo",
  "products.button.new.product": "New product",
  "products.success.productCreated": "Product created successfully",
  "products.success.productUpdated": "Product updated successfully",
  "products.success.productDeleted": "Product deleted successfully",
  "products.button.create": "Create Product",
  "products.button.update": "Update Product",
  "products.catalog.popover.title": "Product type",
  "products.catalog.popover.description":
    "Choose the type of product you want to create.",
  "products.catalog.coming_soon.title": "Coming soon",
  "products.catalog.coming_soon.description":
    "This registration flow will be available soon.",
  "products.catalog.future.machinery_equipment_insurance":
    "Machinery and equipment insurance",
  "products.catalog.future.heavy_vehicles_insurance":
    "Heavy vehicles insurance (trucks and buses)",
  "products.catalog.future.property_insurance": "Property insurance",
  "products.catalog.future.grain_crop_insurance": "Grain crop insurance",
  "products.catalog.future.pme_insurance": "SME insurance",
  "products.catalog.future.civil_liability_insurance":
    "Civil liability insurance",
  "products.catalog.future.do_insurance": "D&O insurance",
  "products.catalog.future.risks_insurance": "Risk insurance",
  "products.catalog.future.travel_insurance": "Travel insurance",
  "products.catalog.future.mobile_insurance": "Mobile phone insurance",
  "products.catalog.future.credit_line_insurance": "Credit insurance",

  "products.credit.sectionTitle": "Credit product",
  "products.credit.configTitle": "Credit configuration",
  "products.credit.infinitySync": "Infinity as sync source",
  "products.credit.validation.maxReleasedGteMin":
    "Maximum released amount must be greater than or equal to minimum",
  "products.credit.validation.maxAgeGteMin":
    "Maximum age must be greater than or equal to minimum",
  "products.credit.modality.consignado": "Payroll-deducted (consignado)",
  "products.credit.modality.pessoal": "Personal",
  "products.credit.modality.flexpay": "Flexpay (card)",
  "products.credit.modality.fgts_antecipacao": "FGTS advance",
  "products.credit.modality.private_label": "Private label (card)",
  "products.credit.modality.home_equity": "Home equity",
  "products.credit.modality.auto_equity": "Auto equity",
  "products.credit.modality.financiamento_veiculo": "Vehicle financing",
  "products.credit.modality.agricola": "Agricultural",
  "products.credit.consignado.publico": "Public sector",
  "products.credit.consignado.privado": "Private sector",
  "products.credit.interest.with_insurance": "With insurance",
  "products.credit.interest.without_insurance": "Without insurance",
  "products.credit.days.business": "Business days",
  "products.credit.days.calendar": "Calendar days",
  "products.credit.days.within_1h": "Up to 1 hour",
  "products.credit.days.immediate": "Immediate",
  "products.credit.remuneration.percent_on_released": "% on released credit",
  "products.credit.remuneration.fixed_per_released": "$ per released credit",
  "products.credit.remuneration.fixed_per_lead": "$ per lead",
  "products.credit.target.individual": "Individual",
  "products.credit.target.company": "Company",
  "products.credit.fields.modality": "Credit modality",
  "products.credit.fields.consignado_scope": "Payroll loan — scope",
  "products.credit.fields.public_sector_category": "Public sector category",
  "products.credit.fields.interest_rate_basis": "Interest rate composition",
  "products.credit.fields.interest_rate_percent": "Estimated interest rate (%)",
  "products.credit.fields.has_value_premise": "Released amount premise",
  "products.credit.fields.min_released_value": "Minimum released amount",
  "products.credit.fields.max_released_value": "Maximum released amount",
  "products.credit.fields.release_deadline_basis": "Estimated credit release timeframe",
  "products.credit.fields.release_deadline_days": "Release deadline (days)",
  "products.credit.fields.remuneration_type": "Product remuneration",
  "products.credit.fields.remuneration_value": "Remuneration value",
  "products.credit.fields.allows_negative_credit": "Allow negative credit bureau",
  "products.credit.fields.estimated_release_basis": "Estimated release basis",
  "products.credit.fields.estimated_release_days": "Estimated release (days)",
  "products.credit.fields.has_age_restriction": "Age restriction",
  "products.credit.fields.min_age_years": "Minimum age (years)",
  "products.credit.fields.max_age_years": "Maximum age (years)",
  "products.credit.fields.target_person_type": "Target PF or PJ",
  "products.credit.fields.notes": "Notes",
  "products.credit.tab.financial": "Rates and amounts",
  "products.credit.tab.remuneration": "Deadlines and remuneration",
  "products.credit.tab.rules_integration": "Credit granting premises",

  //products table
  "products.table.name": "Name",
  "products.table.supplier": "Supplier",
  "products.table.type": "Type",
  "products.table.vigencyType": "Vigency Type",
  "products.table.lastModified": "Last modified",
  "products.table.actions": "Actions",
  "products.table.expandEmpty":
    "No pricing tiers or values to display.",
  "products.table.capital": "Capital:",
  "products.table.minimumValue": "Minimum value:",
  "products.table.premium": "Premium:",
  "products.table.costValue": "Cost value:",
  "products.table.netPremium": "NET premium:",
  "products.table.previewName": "Name:",
  "products.table.previewDescription": "Description:",
  "products.table.planName": "Plan:",
  "products.table.planDescription": "Description:",
  "products.table.noName": "No name",
  "products.table.noDescription": "No description",

  "products.form.fields.product_type": "Product type",
  "products.form.fields.product_type.placeholder": "Select",
  "products.form.fields.name": "Product name",
  "products.form.fields.external_product_id": "External product ID (integration)",
  "products.form.fields.external_product_id_placeholder":
    "E.g. code in the client's system",
  "products.form.fields.code_product": "Product code",
  "products.form.fields.description": "Description",
  "products.form.fields.coverage": "Coverage",
  "products.form.fields.benefits": "Benefits",
  "products.form.fields.cost_price": "Cost price",
  "products.form.fields.final_price": "Preço final",
  "products.form.fields.type_of_vigency": "Type of vigency",
  "products.form.fields.type_of_vigency_product": "Product vigency type",
  "products.form.fields.final_extra_price": "Preço final extra",
  "products.form.fields.insurance_company_id": "Insurance company",
  "products.form.fields.insurance_company_id.placeholder": "Select",
  "products.form.fields.insurance_policy_id": "Policy Id",
  "products.form.fields.policy_number": "Policy number",
  "products.form.fields.cod_sub": "Code Sub",
  "products.form.fields.type_of_recurrence": "Type of recurrence",
  "products.form.fields.type_of_recurrence.placeholder": "Select",
  "products.form.fields.susep_code": "SUSEP Process Code ",
  "products.form.fields.table_code": "Table code",
  "products.form.fields.policy_start_date": "Apolicy start date",
  "products.form.fields.policy_end_date": "Apolicy end date",
  "products.form.fields.capital_value": "Capital value",
  "products.form.fields.premium_value": "Premium value",
  "products.form.fields.iof_value": "IOF value (%)",
  "products.form.fields.agency": "Agency",
  "products.form.fields.lifetime": "Lifetime",
  "products.form.fields.annual": "Annual",
  "products.form.fields.lifetimeCommission": "Lifetime commission",
  "products.form.fields.markup": "Mark-up (%)",
  "products.form.fields.markupIncluded": "Include Markup",
  "products.form.fields.markupMode": "Markup Mode",
  "products.form.fields.markupModePercent": "Percentage (%)",
  "products.form.fields.markupModeValue": "Value (R$)",
  "products.form.fields.markupValue": "Markup Value (R$)",
  "products.form.fields.base_commission_for_sales_team":
    "Base commission for sales team",
  "products.form.fields.base_commission_for_sales_manager":
    "Base commission for sales manager",
  "products.form.fields.form_of_transfer": "Form of transfer",
  "products.form.fields.form_of_transfer.placeholder": "Select",
  "products.form.fields.vigency_days": "Vigency days",
  "products.form.fields.discount_in_plans": "Discount in plans",
  "products.form.fields.min_permitted_age": "Min permitted age",
  "products.form.fields.max_permitted_age": "Max permitted age",
  "products.form.fields.km_max_permitted": "Max km permitted",
  "products.form.fields.min_manufacturing_year": "Min manufacturing year permitted",
  "products.form.fields.support_materials": "Select the support materials",
  "products.form.fields.support_materials_web_link":
    "Support materials web link",
  "products.form.fields.insurance_premium": "Insurance premium (R$)",
  "products.form.fields.extra_premium": "Extra premium (R$)",
  "products.form.fields.total_premium": "Total premium (R$)",
  "products.form.fields.capital_range": "Capital Range",
  "products.form.fields.capital_amount": "Capital amount (R$)",
  "products.form.fields.permitted_age": "Permitted age",
  "products.form.fields.policy_code": "Policy code",
  "products.form.fields.stipulant_code": "Stipulant code",
  "products.form.fields.sub_stipulant_code": "Sub-stipulant code",
  "products.form.fields.code_plan": "Code plan",
  "products.form.fields.extra_premium_policy_code": "Extra premium policy code",
  "products.form.fields.product_description": "Product description",
  "products.form.fields.general_conditions": "General conditions",
  "products.form.fields.max_agency": "Max agency",
  "products.form.fields.agency_installments": "Agency installments",
  "products.form.fields.max_commission": "Max commission",
  "products.form.fields.plan_name_placeholder": "Name of the plan",
  "products.form.fields.plan_title_placeholder": "Plan name",
  "products.form.fields.plan_description": "Plan description",
  "products.form.fields.plan_price": "Plan price",
  "products.form.actions.add_plan": "Add plan",
  "products.form.fields.guarantor": "Guarantor",
  //products tittle tab
  "products.title.tab.data": "Data",
  "products.title.tab.price": "Price",
  "products.title.tab.commercialLoading": "Commercial Loading",
  "products.title.tab.integration": "Integration",
  "products.title.tab.plans": "Plans",

  "products.auto.quoteNotice":
    "Premiums and pricing follow the quotation flow. Use this step to register plans, references, and limits agreed with the partner.",
  "products.auto.plansEmptyTitle": "No plans added yet",
  "products.auto.plansEmptyHint": "Click the button below to create the first plan.",
  "products.auto.addPlan": "Add new plan",

  "products.auto.fields.insurance_company_id": "Insurer / Supplier",
  "products.auto.fields.policy_number": "Policy number",
  "products.auto.fields.policy_start_date": "Policy start date",
  "products.auto.fields.policy_end_date": "Policy end date",
  "products.auto.fields.cod_sub": "Sub code",
  "products.auto.fields.susep_code": "SUSEP process code",
  "products.auto.fields.iof_value": "IOF value (%)",
  "products.auto.fields.type_of_vigency": "Type of vigency",
  "products.auto.fields.km_max_permitted": "Maximum km permitted",
  "products.auto.fields.min_manufacturing_year": "Minimum manufacturing year permitted",
  "products.auto.fields.description": "Description",
  "products.auto.fields.coverage": "Coverage",
  "products.auto.fields.general_conditions": "General conditions",

  "products.vehicle.fields.emission_type": "Emission type",
  "products.vehicle.emission.apolice": "Policy",
  "products.vehicle.emission.bilhete": "Certificate",
  "products.vehicle.fields.collective_policy": "Collective policy product?",
  "products.vehicle.fields.susep_product_code": "SUSEP product code (use NA if not applicable)",
  "products.vehicle.fields.has_km_limit": "Kilometre limits?",
  "products.vehicle.fields.has_year_limit": "Manufacturing year limits?",
  "products.vehicle.fields.max_vehicle_age": "Maximum vehicle age (years)",
  "products.vehicle.fields.premium_mode": "Premium",
  "products.vehicle.premium.prefixed": "Prefixed",
  "products.vehicle.premium.calculated": "Calculated",
  "products.vehicle.fields.prefixed_premium": "Premium amount (BRL)",
  "products.vehicle.fields.has_multiple_plans": "Product has additional plans?",
  "products.vehicle.fields.has_estipulante": "Stipulant?",
  "products.vehicle.fields.stipulant_policy_id": "Stipulant policy ID",
  "products.vehicle.fields.has_sub_estipulante": "Sub-stipulant?",
  "products.vehicle.fields.excluded_risks": "Excluded risks",
  "products.vehicle.commercial.commission": "Commission",
  "products.vehicle.commercial.commission_value": "Commission amount",
  "products.vehicle.commercial.boxTitle": "Commercial terms",
  "products.vehicle.commercial.valueMode": "Value type",
  "products.vehicle.commercial.modePercentage": "Percentage (%)",
  "products.vehicle.commercial.modeCurrency": "Amount (BRL)",
  "products.vehicle.commercial.commission_percent": "Commission percentage (%)",
  "products.vehicle.commercial.commission_value_currency": "Commission amount (BRL)",
  "products.vehicle.commercial.pro_labore_percent": "Pro labore (%)",
  "products.vehicle.commercial.pro_labore_value_currency": "Pro labore amount (BRL)",
  "products.vehicle.commercial.markup_percent": "Markup (%)",
  "products.vehicle.commercial.markupModePercentOnNet":
    "Percentage (%) on NET price",
  "products.vehicle.commercial.markupModeFixedValue": "Fixed amount (BRL)",
  "products.vehicle.commercial.markup_value_currency": "Markup amount (BRL)",
  "products.vehicle.commercial.pro_labore": "Pro labore",
  "products.vehicle.commercial.pro_labore_value": "Pro labore amount",
  "products.vehicle.commercial.markup": "Markup",
  "products.vehicle.commercial.markup_value": "Markup amount",
  "products.vehicle.plan.new_coverages": "New coverages",
  "products.vehicle.plan.adjustments.sectionTitle": "Plan adjustments",
  "products.vehicle.plan.adjustments.sectionHint":
    "Select the adjustment types that apply to this plan and fill in values when required.",
  "products.vehicle.plan.adjustments.types.lmi":
    "LMI - % on FIPE table (maximum indemnity limit)",
  "products.vehicle.plan.adjustments.fipeTablePercent": "FIPE table percentage (%)",
  "products.vehicle.plan.adjustments.insuredSumToggle": "New sum insured?",
  "products.vehicle.plan.adjustments.insuredSumValue": "New sum insured (BRL)",
  "products.vehicle.plan.adjustments.types.is": "IS (sum insured)",
  "products.vehicle.plan.adjustments.types.ages": "Ages",
  "products.vehicle.plan.adjustments.types.usage_in_term":
    "Usage count within the policy term",
  "products.vehicle.plan.adjustments.types.additional_assistance":
    "Additional assistance",
  "products.vehicle.plan.adjustments.types.custom": "Create new item",
  "products.vehicle.plan.adjustments.customLabel": "Item name",
  "products.vehicle.plan.adjustments.assistanceDescription":
    "Additional assistance description",
  "products.vehicle.plan.adjustments.newProductValueToggle":
    "New product value?",
  "products.vehicle.plan.adjustments.newProductValue": "Amount (BRL)",
  "products.vehicle.plan.adjustments.newCommissionToggle":
    "New commission value?",
  "products.vehicle.plan.adjustments.newCommissionPercent": "Commission (%)",

  //products form tab commission
  "products.form.fields.net_premium": "Net premium",
  "products.form.fields.commission_type": "Commission type",
  "products.form.fields.commission_type.placeholder": "Select",
  "products.form.fields.commission_unique": "Unique commission",
  "products.form.fields.comission": "Commission",
  "products.form.fields.pro_labore": "Pro labore",

  //products form tab integration
  "products.form.fields.policy_holder": "Policy Id",
  "products.form.fields.secondary_policy_holder": "Secondary policy Id",
  "products.form.fields.insurance_policy_extra_price_code":
    "Insurance policy extra price code",

  "combo.form.title": "New combo",
  "combo.form.description": "Create a new combo",
  "combo.form.button.close": "Close",
  "combo.form.fields.name": "Combo name",
  "combo.form.fields.value": "Combo value",
  "combo.form.button.create": "Create combo",
  "product.type.insurance_personal_assistance": "Insurance AP",
  "product.type.insurance_group_life": "Insurance VG",
  "product.type.insurance_assistance": "Assistance",
  "product.type.credit": "Credit",
  "product.type.auto": "Auto",
  "product.type.auto_insurance": "Auto Insurance",
  "product.type.moto_insurance": "Motorcycle Insurance",
  "product.type.warranty_insurance": "Warranty insurance",
  "product.type.theft_insurance": "Theft and robbery insurance",
  "product.type_of_vigency.pluriannual": "Multi-year",
  "product.type_of_vigency.annual": "Annual",
  "product.type_of_vigency.monthly": "Monthly",
  "product.type_of_vigency.daily": "Daily",
  "product.type_of_vigency.pay_per_use": "Pay per use",
  "product.type_of_vigency.lifetime": "Lifetime",

  "products.warranty.tab.data": "Data",
  "products.warranty.tab.plans": "Plans",
  "products.warranty.fields.guarantor": "Guarantor / supplier",
  "products.warranty.fields.emission_type": "Emission type",
  "products.warranty.emission.apolice": "Policy",
  "products.warranty.emission.bilhete": "Certificate",
  "products.warranty.fields.collective_policy": "Collective policy product?",
  "products.warranty.fields.contract_active": "Active contract?",
  "products.warranty.fields.contract_section_title": "Contract in force",
  "products.warranty.fields.contract_start": "Contract start date",
  "products.warranty.fields.contract_end": "Contract end date",
  "products.warranty.vigency.pluriannual": "Multi-year",
  "products.warranty.vigency.annual": "Annual",
  "products.warranty.vigency.monthly": "Monthly",
  "products.warranty.vigency.daily": "Daily",
  "products.warranty.vigency.pay_per_use": "Pay per use",
  "products.warranty.fields.commercialization_rules": "Commercialization rules",
  "products.warranty.rules.age": "Age",
  "products.warranty.rules.gender": "Gender",
  "products.warranty.rules.km": "Mileage",
  "products.warranty.rules.location_state": "State location",
  "products.warranty.rules.location_city": "City location",
  "products.warranty.rules.vehicle_age": "Vehicle age",
  "products.warranty.rules.vehicle_type": "Vehicle type",
  "products.warranty.rules.model_or_brand_groups":
    "Model and/or brand groups",
  "products.warranty.rules.custom": "New item",
  "products.warranty.fields.gender": "Gender",
  "products.warranty.gender.feminine": "Female",
  "products.warranty.gender.masculine": "Male",
  "products.warranty.gender.lgbt": "LGBT",
  "products.warranty.fields.km_min": "Minimum km",
  "products.warranty.fields.km_max": "Maximum km",
  "products.warranty.fields.location_mode": "Location",
  "products.warranty.location.states": "States",
  "products.warranty.location.cities": "Cities",
  "products.warranty.fields.location_text": "States and cities (text)",
  "products.warranty.fields.vehicle_age_rule": "Vehicle age",
  "products.warranty.vehicle_age.age_only": "Age only",
  "products.warranty.vehicle_age.age_and_model": "Age and model",
  "products.warranty.vehicle_age.model_or_groups": "Model and/or brand groups",
  "products.warranty.fields.vehicle_age_only_min": "Age (years)",
  "products.warranty.fields.vehicle_age_and_model_rules": "Age and model rules",
  "products.warranty.fields.vehicle_type_rules": "Type / brand rules",
  "products.warranty.fields.excluded_items": "Excluded items",
  "products.warranty.fields.premium_price_type": "Premium price",
  "products.warranty.premium.net": "NET price",
  "products.warranty.premium.commissioned": "Commissioned price",
  "products.warranty.fields.net_price": "NET price (BRL)",
  "products.warranty.fields.commissioned_price": "Commissioned price (BRL)",
  "products.warranty.fields.commission_percent": "Commission (%)",
  "products.warranty.fields.markup_enabled": "Markup",
  "products.warranty.fields.markup_mode": "Markup type",
  "products.warranty.markup.mode_percent_on_net": "Percentage (%) on NET price",
  "products.warranty.markup.mode_fixed_value": "Fixed amount (BRL)",
  "products.warranty.fields.net_price_markup_base":
    "NET price — base for markup % (BRL)",
  "products.warranty.fields.markup_value_currency": "Markup amount (BRL)",
  "products.warranty.fields.markup_value_percent": "Markup (%)",
  "products.warranty.fields.pro_labore_enabled": "Pro labore",
  "products.warranty.fields.pro_labore_mode": "Pro labore mode",
  "products.warranty.pro_labore.real": "Amount (BRL)",
  "products.warranty.pro_labore.percent": "Percentage (%)",
  "products.warranty.pro_labore.custom_rule": "Custom rule",
  "products.warranty.fields.pro_labore_custom_rule": "Rule description",
  "products.warranty.fields.pro_labore_value": "Pro labore value",
  "products.warranty.fields.has_additional_plans": "Product has additional plans?",
  "products.warranty.fields.infinity_sync_as_source": "Sync as Infinity → Soulhub source",
  "products.warranty.plans.disabled_hint": "Enable \"Product has additional plans?\" on the Data tab to add plans.",
  "products.warranty.plans.plan_prefix": "Plan",
  "products.warranty.plans.name": "Plan name",
  "products.warranty.plans.description": "Plan description",
  "products.warranty.plans.new_coverages": "New coverages",
  "products.warranty.plans.adjustments": "Plan adjustments",
  "products.warranty.plans.adjustment_type": "Adjustment type",
  "products.warranty.adjustment.lmi": "LMI (max indemnity limit)",
  "products.warranty.adjustment.is": "IS (sum insured)",
  "products.warranty.adjustment.ages": "Ages",
  "products.warranty.adjustment.usage_qty_in_term": "Usage count in term",
  "products.warranty.adjustment.additional_assistance": "Additional assistance",
  "products.warranty.adjustment.custom": "New item",
  "products.warranty.plans.new_assistance_value": "New assistance value?",
  "products.warranty.plans.assistance_value_amount": "Assistance amount (BRL)",
  "products.warranty.plans.new_commission": "New commission?",
  "products.warranty.plans.commission_percent": "Commission (%)",
  "products.warranty.plans.additional_assistance_text": "Additional assistance (text)",
  "products.warranty.plans.add": "Add plan",
  "products.warranty.plans.add_adjustment": "Add adjustment",
  "products.warranty.actions.save": "Save",
  "products.warranty.actions.update": "Update product",
  "products.theft.tab.data": "Data",
  "products.theft.tab.plans": "Plans",
  "products.theft.fields.guarantor": "Guarantor / supplier",
  "products.theft.fields.emission_type": "Emission type",
  "products.theft.emission.apolice": "Policy",
  "products.theft.emission.bilhete": "Certificate",
  "products.theft.fields.collective_policy": "Collective policy product?",
  "products.theft.fields.contract_active": "Active contract?",
  "products.theft.fields.contract_start": "Contract start date",
  "products.theft.fields.contract_end": "Contract end date",
  "products.theft.vigency.pluriannual": "Multi-year",
  "products.theft.vigency.annual": "Annual",
  "products.theft.vigency.monthly": "Monthly",
  "products.theft.vigency.daily": "Daily",
  "products.theft.vigency.pay_per_use": "Pay per use",
  "products.theft.fields.commercialization_rules": "Commercialization rules",
  "products.theft.rules.age": "Age",
  "products.theft.rules.gender": "Gender",
  "products.theft.rules.km": "Mileage",
  "products.theft.rules.location_state": "State location",
  "products.theft.rules.location_city": "City location",
  "products.theft.rules.vehicle_age": "Vehicle age",
  "products.theft.rules.vehicle_type": "Vehicle type",
  "products.theft.rules.model_or_brand_groups":
    "Model and/or brand groups",
  "products.theft.rules.custom": "New item",
  "products.theft.fields.gender": "Gender",
  "products.theft.gender.feminine": "Female",
  "products.theft.gender.masculine": "Male",
  "products.theft.gender.lgbt": "LGBT",
  "products.theft.fields.km_min": "Minimum km",
  "products.theft.fields.km_max": "Maximum km",
  "products.theft.fields.location_mode": "Location",
  "products.theft.location.states": "States",
  "products.theft.location.cities": "Cities",
  "products.theft.fields.location_text": "States and cities (text)",
  "products.theft.fields.vehicle_age_rule": "Vehicle age",
  "products.theft.vehicle_age.age_only": "Age only",
  "products.theft.vehicle_age.age_and_model": "Age and model",
  "products.theft.vehicle_age.model_or_groups": "Model and/or brand groups",
  "products.theft.fields.vehicle_age_only_min": "Age (years)",
  "products.theft.fields.vehicle_age_and_model_rules": "Age and model rules",
  "products.theft.fields.vehicle_type_rules": "Type / brand rules",
  "products.theft.fields.excluded_items": "Excluded items",
  "products.theft.fields.premium_price_type": "Premium price",
  "products.theft.premium.net": "NET price",
  "products.theft.premium.commissioned": "Commissioned price",
  "products.theft.fields.net_price": "NET price (BRL)",
  "products.theft.fields.commissioned_price": "Commissioned price (BRL)",
  "products.theft.fields.commission_percent": "Commission (%)",
  "products.theft.fields.markup_enabled": "Markup",
  "products.theft.fields.markup_mode": "Markup type",
  "products.theft.markup.mode_percent_on_net": "Percentage (%) on NET price",
  "products.theft.markup.mode_fixed_value": "Fixed amount (BRL)",
  "products.theft.fields.net_price_markup_base":
    "NET price — base for markup % (BRL)",
  "products.theft.fields.markup_value_currency": "Markup amount (BRL)",
  "products.theft.fields.markup_value_percent": "Markup (%)",
  "products.theft.fields.pro_labore_enabled": "Pro labore",
  "products.theft.fields.pro_labore_mode": "Pro labore mode",
  "products.theft.pro_labore.real": "Amount (BRL)",
  "products.theft.pro_labore.percent": "Percentage (%)",
  "products.theft.pro_labore.custom_rule": "Custom rule",
  "products.theft.fields.pro_labore_custom_rule": "Rule description",
  "products.theft.fields.pro_labore_value": "Pro labore value",
  "products.theft.fields.has_additional_plans": "Product has additional plans?",
  "products.theft.fields.infinity_sync_as_source": "Sync as Infinity → Soulhub source",
  "products.theft.plans.disabled_hint": "Enable \"Product has additional plans?\" on the Data tab to add plans.",
  "products.theft.plans.plan_prefix": "Plan",
  "products.theft.plans.name": "Plan name",
  "products.theft.plans.description": "Plan description",
  "products.theft.plans.new_coverages": "New coverages",
  "products.theft.plans.adjustments": "Plan adjustments",
  "products.theft.plans.adjustment_type": "Adjustment type",
  "products.theft.adjustment.lmi": "LMI (max indemnity limit)",
  "products.theft.adjustment.is": "IS (sum insured)",
  "products.theft.adjustment.ages": "Ages",
  "products.theft.adjustment.usage_qty_in_term": "Usage count in term",
  "products.theft.adjustment.additional_assistance": "Additional assistance",
  "products.theft.adjustment.custom": "New item",
  "products.theft.plans.new_assistance_value": "New assistance value?",
  "products.theft.plans.assistance_value_amount": "Assistance amount (BRL)",
  "products.theft.plans.new_commission": "New commission?",
  "products.theft.plans.commission_percent": "Commission (%)",
  "products.theft.plans.additional_assistance_text": "Additional assistance (text)",
  "products.theft.plans.add": "Add plan",
  "products.theft.plans.add_adjustment": "Add adjustment",
  "products.theft.actions.save": "Save",
  "products.theft.actions.update": "Update product",

  //campaigns
  "campaigns.title": "Campaigns",
  "campaigns.description": "Manage your campaigns",
  "campaigns.no_campaigns": "No campaigns found",
  "campaigns.table.name": "Name",
  "campaigns.table.project": "Project",
  "campaigns.table.plan": "Plan",
  "campaigns.table.channel": "Channel",
  "campaigns.table.status": "Status",
  "campaigns.form.fields.name": "Campaign name",
  "campaigns.form.fields.project": "Project",
  "campaigns.form.fields.projectPlaceholder": "Select a project",
  "campaigns.form.fields.plan": "Associated plan(s)",
  "campaigns.form.fields.channel": "Channel",
  "campaigns.form.fields.status.label": "Status",
  "campaigns.form.fields.status.options.draft": "Draft",
  "campaigns.form.fields.status.options.active": "Active",
  "campaigns.form.fields.status.options.paused": "Paused",
  "campaigns.form.noProjectSelected": "Select a project to load plans.",
  "campaigns.form.noPlansForOrganization":
    "No plans were found for this organization.",
  "campaigns.form.noPlansForProject": "No plans found for this project.",
  "campaigns.form.editTitle": "Edit campaign",
  "campaigns.form.whatsappMetaSection": "WhatsApp (Meta) — outbound template",
  "campaigns.form.whatsappMetaConfig": "Meta connection",
  "campaigns.form.whatsappMetaConfigPlaceholder": "Select a saved Meta connection",
  "campaigns.form.whatsappSenderPhone": "Sender number (Graph)",
  "campaigns.form.whatsappSenderPhonePlaceholder": "Select the sending phone number ID",
  "campaigns.form.whatsappTemplate": "Approved template",
  "campaigns.form.whatsappTemplatePlaceholder": "Select template name and language",
  "campaigns.form.whatsappBodyParams": "Template body parameters (one per line)",
  "campaigns.form.whatsappBodyParamsHint":
    "For positional placeholders use one value per line (order {{1}}, {{2}}, …). For named placeholders use one line per variable: name=value (e.g. nome=João). Do not mix both styles. Leave empty if there are no variables.",
  "campaigns.form.whatsappMetaIncomplete":
    "Fill all Meta fields (connection, sender phone, template name and language) or leave them all empty.",
  "campaigns.channel.whatsapp": "WhatsApp",
  "campaigns.status.draft": "Draft",
  "campaigns.status.active": "Active",
  "campaigns.status.paused": "Paused",
  "campaigns.success.created": "Campaign created successfully",
  "campaigns.success.updated": "Campaign updated successfully",
  "campaigns.success.deleted": "Campaign deleted successfully",
  "campaigns.errors.loadingPlans": "Could not load plans for the project.",
  "campaigns.errors.loadingProjects": "Could not load projects.",
  "campaigns.errors.planNotInProject":
    "One or more selected plans do not belong to the selected project.",
  "campaigns.actions.viewCampaigns": "View campaigns",
  "campaigns.actions.viewDetails": "View details",
  "campaigns.actions.uploadList": "Upload list",
  "campaigns.dashboard.total": "Total campaigns",
  "campaigns.dashboard.active": "Active",
  "campaigns.dashboard.draft": "Draft",
  "campaigns.dashboard.paused": "Paused",
  "campaigns.upload.title": "Contacts upload",
  "campaigns.upload.description":
    "Upload a CSV or XLSX file to process campaign contacts.",
  "campaigns.upload.form.title":
    "Drag and drop your file here or click to select",
  "campaigns.upload.form.downloadTemplate": "Download template sheet",
  "campaigns.upload.form.description":
    "Accepted formats: .csv and .xlsx. Phone is required.",
  "campaigns.upload.form.submit": "Process list",
  "campaigns.upload.processing": "Processing file...",
  "campaigns.upload.success.processed": "List processed successfully",
  "campaigns.upload.summary.valid": "Valid",
  "campaigns.upload.summary.invalid": "Invalid",
  "campaigns.upload.summary.duplicate": "Duplicates",
  "campaigns.upload.summary.inserted": "Inserted",
  "campaigns.upload.preview.title": "Preview (sample)",
  "campaigns.upload.preview.empty":
    "Select a file to preview the processed rows.",
  "campaigns.upload.preview.columns.line": "Line",
  "campaigns.upload.preview.columns.company": "Company",
  "campaigns.upload.preview.columns.first_name": "First Name",
  "campaigns.upload.preview.columns.last_name": "Last Name",
  "campaigns.upload.preview.columns.email": "E-mail",
  "campaigns.upload.preview.columns.name": "Name",
  "campaigns.upload.preview.columns.phone": "Phone",
  "campaigns.upload.preview.columns.phone_2": "Phone 2",
  "campaigns.upload.preview.columns.document_number": "Company/Personal ID",
  "campaigns.upload.preview.columns.status": "Status",
  "campaigns.upload.preview.columns.reason": "Reason",
  "campaigns.upload.status.valid": "Valid",
  "campaigns.upload.status.invalid": "Invalid",
  "campaigns.upload.status.duplicate": "Duplicate",
  "campaigns.upload.validation.invalidExtension":
    "Select a .csv or .xlsx file",
  "campaigns.upload.errors.generic":
    "Could not process the file. Please try again.",
  "campaigns.upload.errors.templateDownload":
    "Could not download the template sheet.",
  "campaigns.upload.errors.invalidFile": "Could not read the selected file.",
  "campaigns.upload.errors.phoneColumnMissing":
    "The phone column is required in the uploaded file.",
  "campaigns.upload.errors.campaignNotFound":
    "Campaign not found for this upload.",
  "campaigns.upload.errors.campaignIdMissing":
    "Could not identify campaign for upload.",
  "campaigns.upload.modal.title": "Upload lead list",
  "campaigns.upload.modal.description":
    "Download the template, fill in your contacts, and upload the file as CSV or XLSX.",
  "campaigns.upload.modal.templateLabel": "Spreadsheet template",
  "campaigns.upload.modal.uploadLabel": "Upload file",
  "campaigns.upload.modal.selectFromComputer": "Select file from computer",
  "campaigns.upload.modal.templateDownloaded": "Template downloaded successfully.",
  "campaigns.upload.modal.selectFileFirst": "Select or drop a file to upload.",
  "campaigns.upload.modal.fileLoaded": "File ready to send. Click X to replace.",
  "campaigns.details.title": "Campaign details",
  "campaigns.details.description":
    "View campaign data and already uploaded contacts.",
  "campaigns.details.emptyCampaign": "Campaign not found.",
  "campaigns.details.info.title": "Campaign data",
  "campaigns.details.info.name": "Name",
  "campaigns.details.info.status": "Status",
  "campaigns.details.info.channel": "Channel",
  "campaigns.details.info.projectId": "Project",
  "campaigns.details.info.plans": "Plans",
  "campaigns.details.info.whatsappTemplate": "WhatsApp template (Meta)",
  "campaigns.details.dispatch.button": "Send template to all contacts",
  "campaigns.details.dispatch.dialogTitle": "WhatsApp dispatch",
  "campaigns.details.dispatch.dialogDescription":
    "Choose the Meta connection, sender number, and template. Values may be pre-filled from the campaign if you saved them when editing.",
  "campaigns.details.dispatch.bodyParamsHint":
    "Optional: if the Meta template body only uses name/nome and message/mensagem variables, you can leave this field empty — values are filled per lead. If it only has {{1}} and {{2}}, you can also leave it empty ({{1}} = lead name, {{2}} = AI initial message). Otherwise use one line per variable (name=value); name/nome and message/mensagem lines may have an empty value. Run enrichment first for the initial message. Do not mix plain positional lines with name=value lines.",
  "campaigns.details.dispatch.dialogSubmit": "Continue to confirmation",
  "campaigns.details.dispatch.confirmTitle": "Send WhatsApp template to all leads?",
  "campaigns.details.dispatch.confirmDescription":
    "This will trigger Meta Cloud API sends for every contact in this campaign. Use only for audiences with opt-in. The operation may take several minutes.",
  "campaigns.details.dispatch.successTitle": "Dispatch finished",
  "campaigns.details.dispatch.successSent": "Sent",
  "campaigns.details.dispatch.successFailed": "Failed",
  "campaigns.details.dispatch.successTotal": "Total",
  "campaigns.details.contacts.title": "Uploaded contacts",
  "campaigns.details.contacts.empty":
    "No contacts uploaded for this campaign.",
  "campaigns.details.contacts.columns.company": "Company",
  "campaigns.details.contacts.columns.name": "Name",
  "campaigns.details.contacts.columns.first_name": "First Name",
  "campaigns.details.contacts.columns.last_name": "Last Name",
  "campaigns.details.contacts.columns.email": "E-mail",
  "campaigns.details.contacts.columns.phone": "Phone",
  "campaigns.details.contacts.columns.phone_2": "Phone 2",
  "campaigns.details.contacts.columns.document_number": "Company/Personal ID",
  "campaigns.details.contacts.columns.createdAt": "Uploaded at",
  "campaigns.details.dashboard.totalContacts": "Total contacts",
  "campaigns.details.dashboard.withName": "Contacts with name",
  "campaigns.details.dashboard.withoutName": "Without name",
  "campaigns.details.dashboard.lastUpload": "Last upload",

  "campaigns.dashboard.export": "Export",
  "campaigns.dashboard.pause": "Pause",
  "campaigns.dashboard.resume": "Resume",
  "campaigns.dashboard.adjustSettings": "Adjust settings",
  "campaigns.dashboard.unitCostBadge": "Unit cost: {{value}}",
  "campaigns.dashboard.kpi.sent": "Sends completed",
  "campaigns.dashboard.kpi.sentToday": "+ today: {{count}}",
  "campaigns.dashboard.kpi.delivered": "Delivered",
  "campaigns.dashboard.kpi.deliveryRate": "Rate {{value}}%",
  "campaigns.dashboard.kpi.chats": "Chats started",
  "campaigns.dashboard.kpi.chatConversion": "Conversion {{value}}%",
  "campaigns.dashboard.kpi.totalCost": "Total cost",
  "campaigns.dashboard.kpi.projection":
    "Projection {{value}} (if +20% sends)",
  "campaigns.dashboard.funnel.title": "Execution funnel",
  "campaigns.dashboard.funnel.subtitle":
    "Quick view: sends → delivered → chats started.",
  "campaigns.dashboard.funnel.refresh": "Refresh",
  "campaigns.dashboard.funnel.range7": "Last 7 days",
  "campaigns.dashboard.funnel.range30": "Last 30 days",
  "campaigns.dashboard.funnel.range90": "Last 90 days",
  "campaigns.dashboard.funnel.sent": "Sends",
  "campaigns.dashboard.funnel.delivered": "Delivered",
  "campaigns.dashboard.funnel.chats": "Chats started",
  "campaigns.dashboard.runs.title": "Recent sends",
  "campaigns.dashboard.runs.subtitle": "Quick audit by batch and status.",
  "campaigns.dashboard.runs.searchPlaceholder": "Search batch or template",
  "campaigns.dashboard.runs.colDate": "Date/Time",
  "campaigns.dashboard.runs.colBatch": "Batch",
  "campaigns.dashboard.runs.colTemplate": "Template",
  "campaigns.dashboard.runs.colSent": "Sends",
  "campaigns.dashboard.runs.colDelivered": "Delivered",
  "campaigns.dashboard.runs.colChats": "Chats",
  "campaigns.dashboard.runs.colCost": "Cost",
  "campaigns.dashboard.costs.title": "Costs",
  "campaigns.dashboard.costs.subtitle":
    "Estimated cost per send and breakdown.",
  "campaigns.dashboard.costs.perDispatch": "Cost per send",
  "campaigns.dashboard.costs.budget": "Budget (optional)",
  "campaigns.dashboard.costs.used": "Used {{value}}%",
  "campaigns.dashboard.costs.tip":
    "Tip: set a budget to track spend against the campaign.",
  "campaigns.dashboard.actions.title": "Quick actions",
  "campaigns.dashboard.actions.subtitle": "Operate without leaving the page.",
  "campaigns.dashboard.actions.retryFailed": "Retry failures",
  "campaigns.dashboard.actions.changeTemplate": "Change template",
  "campaigns.dashboard.actions.newBatch": "New batch",
  "campaigns.dashboard.costSheet.title": "Campaign costs",
  "campaigns.dashboard.costSheet.unit": "Unit cost (BRL)",
  "campaigns.dashboard.costSheet.budget": "Budget (BRL, optional)",
  "campaigns.dashboard.costSheet.save": "Save",
  "campaigns.dashboard.costSheet.invalidMoney":
    "Enter valid numbers (e.g. 0.44).",
  "campaigns.dashboard.costSheet.success": "Costs updated.",
  "campaigns.dashboard.pauseSuccess": "Campaign paused.",
  "campaigns.dashboard.resumeSuccess": "Campaign reactivated.",
  "campaigns.dashboard.na": "—",
  "campaigns.dashboard.windowHint": "Funnel and table filter",
  "campaigns.dashboard.headerPeriod": "Period: last {{days}} days",

  "campaigns.details.errors.loadCampaign":
    "Could not load campaign data.",
  "campaigns.details.errors.loadContacts":
    "Could not load campaign contacts.",
  "campaigns.details.enrich.button": "Enrich data",
  "campaigns.details.enrich.buttonLoading": "Enriching...",
  "campaigns.details.enrich.banner": "Enriching contacts. Please wait...",
  "campaigns.details.enrich.bannerAi": "Enriching contacts with AI. Please wait...",
  "campaigns.details.enrich.success": "Enrichment completed.",
  "campaigns.details.enrich.successProcessed": "contact(s) enriched.",
  "campaigns.details.enrich.error": "Failed to enrich contacts.",
  "campaigns.details.enrich.failedCount": "contact(s) failed.",
  "campaigns.details.contacts.columns.enrichmentStatus": "Status",
  "campaigns.details.contacts.columns.enrichedData": "Profile",
  "campaigns.details.contacts.columns.initialMessage": "Initial message",
  "campaigns.details.contacts.enrichment.enriched": "Enriched",
  "campaigns.details.contacts.enrichment.pending": "Pending",
  "campaigns.details.contacts.enrichment.failed": "Error",
  "campaigns.details.contacts.testFlow": "Test flow",
  "campaigns.details.chat.title": "Test chat",
  "campaigns.details.chat.placeholder": "Type your message...",
  "campaigns.details.chat.send": "Send",
  "campaigns.details.chat.typing": "Typing...",
  "campaigns.details.chat.openingGeneric": "Hello!",
  "campaigns.details.chat.openingNamed": "Hello, {{name}}!",

  "campaigns.whatsappMeta.title": "WhatsApp (Meta)",
  "campaigns.whatsappMeta.description":
    "Connect your WABA with a Graph API access token and browse phone numbers and approved templates (read-only).",
  "campaigns.whatsappMeta.add": "New connection",
  "campaigns.whatsappMeta.edit": "Edit connection",
  "campaigns.whatsappMeta.cancel": "Cancel",
  "campaigns.whatsappMeta.save": "Save",
  "campaigns.whatsappMeta.delete": "Delete",
  "campaigns.whatsappMeta.dialogIntro":
    "Enter the WABA ID and an access token with permission on that WhatsApp Business Account. Numbers and templates are still managed in Meta Business Manager.",
  "campaigns.whatsappMeta.tokenOptionalOnEdit":
    "Leave the token empty to keep the current one.",
  "campaigns.whatsappMeta.empty": "No connections yet.",
  "campaigns.whatsappMeta.workflowNote":
    "Open a connection from the table to view phone numbers and templates from Meta on a dedicated screen.",
  "campaigns.whatsappMeta.connectionsTitle": "Connections",
  "campaigns.whatsappMeta.backToList": "Back to connections",
  "campaigns.whatsappMeta.notFound":
    "This connection no longer exists or you do not have access.",
  "campaigns.whatsappMeta.selectConnectionHint":
    "Select a connection in the table above to view numbers and templates.",
  "campaigns.whatsappMeta.phoneNumbersTitle": "Phone numbers (Meta)",
  "campaigns.whatsappMeta.phoneNumbersEmpty":
    "No phone numbers returned by Meta for this WABA.",
  "campaigns.whatsappMeta.templatesTitle": "Templates (Meta)",
  "campaigns.whatsappMeta.templatesEmpty": "No templates returned by Meta.",
  "campaigns.whatsappMeta.loadMoreTemplates": "Load more templates",
  "campaigns.whatsappMeta.fields.label": "Connection name (optional)",
  "campaigns.whatsappMeta.fields.wabaId": "WABA ID",
  "campaigns.whatsappMeta.fields.accessToken": "Access token",
  "campaigns.whatsappMeta.table.label": "Name",
  "campaigns.whatsappMeta.table.wabaId": "WABA ID",
  "campaigns.whatsappMeta.table.token": "Token",
  "campaigns.whatsappMeta.table.actions": "Actions",
  "campaigns.whatsappMeta.tokenConfigured": "Configured",
  "campaigns.whatsappMeta.tokenMissing": "—",
  "campaigns.whatsappMeta.phoneTable.display": "Number",
  "campaigns.whatsappMeta.phoneTable.verifiedName": "Verified name",
  "campaigns.whatsappMeta.phoneTable.id": "ID",
  "campaigns.whatsappMeta.templatesTable.name": "Name",
  "campaigns.whatsappMeta.templatesTable.status": "Status",
  "campaigns.whatsappMeta.templatesTable.language": "Language",
  "campaigns.whatsappMeta.templatesDetail.hint":
    "Expand a template to see category, Graph ID, quality score, and each component (header, body with placeholders, footer, and buttons).",
  "campaigns.whatsappMeta.templatesDetail.category": "Category",
  "campaigns.whatsappMeta.templatesDetail.templateId": "Template ID",
  "campaigns.whatsappMeta.templatesDetail.qualityScore": "Quality score",
  "campaigns.whatsappMeta.templatesDetail.structure": "Structure (Meta components)",
  "campaigns.whatsappMeta.templatesDetail.noComponents":
    "Meta did not return components for this template.",
  "campaigns.whatsappMeta.templatesDetail.emptyComponents": "Empty components array.",
  "campaigns.whatsappMeta.templatesDetail.component.buttons": "Buttons",
  "campaigns.whatsappMeta.templatesDetail.component.noText":
    "No text in this component (e.g. media header or dynamic only).",
  "campaigns.whatsappMeta.deleteConfirmTitle": "Delete connection?",
  "campaigns.whatsappMeta.deleteConfirmDescription":
    "This removes the saved connection from Infinity. Nothing is changed in Meta.",
  "campaigns.whatsappMeta.success.created": "Connection created",
  "campaigns.whatsappMeta.success.updated": "Connection updated",
  "campaigns.whatsappMeta.success.deleted": "Connection removed",
  "campaigns.whatsappMeta.errors.loadConfigs":
    "Could not load connections. Check your session and try again.",

  //components upload-avatar
  "components.uploadAvatar.changePictureButton": "Change picture",
  "components.uploadAvatar.changePictureButtonDescription":
    "Accepted formats: JPG, JPEG, PNG or GIF. Maximum size of 5MB.",
  "components.uploadAvatar.clickToCrop": "Click to crop",

  //team
  "users.tabs.data": "Data",
  "users.fields.firstName": "First Name",
  "users.fields.lastName": "Last Name",
  "users.fields.document": "Document",
  "users.fields.birthDate": "Birth Date",
  "users.fields.phone": "Phone",
  "users.fields.zipcode": "ZIP Code",
  "users.fields.state": "State",
  "users.fields.city": "City",
  "users.fields.neighborhood": "Neighborhood",
  "users.fields.street": "Street",
  "users.fields.number": "Number",
  "users.fields.complement": "Complement",

  "users.tabs.login": "Login",
  "users.fields.email": "E-mail",
  "users.fields.password": "Password",
  "users.fields.recoveryEmail": "Recovery E-mail",
  "users.fields.documentType": "Two-Factor Authentication",
  "users.fields.usbKey": "USB Key",

  "users.tabs.permissions": "Permissions",
  "users.fields.selectAccessLevel": "Select Access Level",
  "users.roles.admin": "Administrator",
  "users.roles.sales": "Sales",
  "users.roles.support": "Support",
  "users.roles.reportsViewOnly": "Reports (View Only)",

  "users.permissions.orSelectIndividually": "Or select individually",
  "users.permissions.selectAll": "Select all",
  "users.permissions.createProducts": "Create Products",
  "users.permissions.createUsers": "Create Users",
  "users.permissions.createCampaigns": "Create Campaigns",
  "users.permissions.accessFinancialReports": "Access Financial Reports",
  "users.permissions.managePartners": "Manage Partners",
  "users.permissions.accessSalesDashboard": "Access Sales Dashboard",
  "users.permissions.createPlatforms": "Create Platforms",
  "users.permissions.manageCancellations": "Manage Cancellations",
  "users.permissions.accessDashboard": "Access Dashboard",
  "users.permissions.createTeams": "Create Teams",

  "users.permissions.subtitles.createProducts":
    "The user has permission to register any product on the platform",
  "users.permissions.subtitles.createUsers":
    "The user has permission to register new users on the platform",
  "users.permissions.subtitles.createCampaigns":
    "The user has permission to create advertising campaigns on the platform",
  "users.permissions.subtitles.accessFinancialReports":
    "The user has permission to access financial reports on the platform",
  "users.permissions.subtitles.managePartners":
    "The user has permission to manage clients on the platform",
  "users.permissions.subtitles.accessSalesDashboard":
    "The user has permission to access the sales dashboard on the platform",
  "users.permissions.subtitles.createPlatforms":
    "The user has permission to create new platforms on the platform",
  "users.permissions.subtitles.manageCancellations":
    "The user has permission to manage service cancellations on the platform",
  "users.permissions.subtitles.accessDashboard":
    "The user has permission to access the main dashboard on the platform",
  "users.permissions.subtitles.createTeams":
    "The user has permission to create teams on the platform",
  "users.no_users": "No users found",

  //errors
  "errors.zipcodeNotFound": "ZIP code not found or invalid.",

  //knowledgeBase
  "knowledgeBase.form.title": "Knowledge Base",
  "knowledgeBase.form.description": "Manage partner knowledge base",
  "knowledgeBase.form.fields.name": "Knowledge base name",
  "knowledgeBase.form.fields.client": "Partner",
  "knowledgeBase.form.fields.files": "Files",
  "knowledgeBase.form.placeholders.name": "Enter knowledge base name",
  "knowledgeBase.form.placeholders.client": "Select partner",
  "knowledgeBase.form.descriptions.files": "Select files to upload",
  "knowledgeBase.form.actions.selectFiles": "Select files",
  "knowledgeBase.form.actions.upload": "Upload",
  "knowledgeBase.form.selectedFiles": "Selected files",
  "knowledgeBase.success.filesUploaded": "Files uploaded successfully",

  //texts
  "texts.loading": "Loading...",
};
